import React, { useCallback, useEffect, useMemo, useRef, useState } from 'react';
import { Alert, Box, Button, Checkbox, CircularProgress, FormControlLabel, Grid, Snackbar, Stack, TextField, Typography } from '@mui/material';
import ArrowBack from '@mui/icons-material/ArrowBack';
import Save from '@mui/icons-material/Save';
import { post, postFromData } from '../../services/api';
import { useSelector } from 'react-redux';
import ENDPOINTS from '../../utils/constants/endpoints';
import { useNavigate, useLocation } from 'react-router-dom';
import { BusDetailComponent } from '../../components/addFormComponent.js/BusDetailComponent';
import { AddPermitComponent } from '../../components/addFormComponent.js/AddPermitComponent';
import { BusFormSection, busFormSx } from '../../components/addFormComponent.js/BusFormSection';
import BusDocumentUpload from '../../components/addFormComponent.js/BusDocumentUpload';

const AddBus = () => {
    const navigate = useNavigate();
    const { role_id, user } = useSelector((state) => state.auth);

    const location = useLocation();
    const editData = location.state?.editData || null;


    const [loadingDetails, setLoadingDetails] = useState(Boolean(editData));
    const [loadError, setLoadError] = useState('');
    const submitting = useRef(false);
    const previewUrls = useRef({});
    const [fieldErrors, setFieldErrors] = useState({});
    const [uploadErrors, setUploadErrors] = useState({});
    useEffect(() => () => Object.values(previewUrls.current).forEach(url => URL.revokeObjectURL(url)), []);
    const [form, setForm] = useState({});
    const defaultForm = {
        token: localStorage.getItem("token") || "",
        users_id: user?.users_id || user?.id || "",
        role_id: role_id || "",
        school_id: user?.users_id || user?.id || "",
        bus_number: "",
        vehicle_type_id: "",
        owner_name: "",
        capacity: "",
        model: "",
        purchase_year: "",
        rc_issue_date: "",
        rc_valid_upto: "",
        rc_number: "",
        upload_photo_1: "",
        upload_photo_2: "",
        upload_photo_3: "",
        upload_photo_4: "",
        upload_rc: "",
        fitness_number: "",
        fitness_issued_date: "",
        fitness_valid_upto: "",
        upload_fitness: "",
        permit_number: "",
        permit_type: "",
        permit_issued_date: "",
        permit_valid_upto: "",
        upload_permit: "",
        insurance_number: "",
        insurance_company: "",
        insurance_issued_date: "",
        insurance_valid_upto: "",
        premium_amount: "",
        upload_insurance: "",
        puc_number: "",
        puc_issued_date: "",
        puc_valid_upto: "",
        upload_puc: "",
        declaration: 0
    };

    useEffect(() => {
        const token = localStorage.getItem("token");

        if (!token) {
            navigate("/login");
        }

        if (editData) {

            FetchViewData(editData.id);
        } else {
            setForm(defaultForm);
            // Default empty form for Add
            // setForm({
            //     token: token,
            //     users_id: user?.id,
            //     role_id: role_id,
            //     school_id: user?.id,
            //     bus_number: "",
            //     upload_photo_1: "",
            //     upload_photo_2: "",
            //     upload_photo_3: "",
            //     upload_photo_4: "",
            //     rc_number: "",
            //     owner_name: "",
            //     capacity: "",
            //     model: "",
            //     purchase_year: "",
            //     rc_issue_date: "",
            //     rc_valid_upto: "",
            //     upload_rc: "",
            //     fitness_number: "",
            //     fitness_issued_date: "",
            //     fitness_valid_upto: "",
            //     upload_fitness: "",
            //     permit_number: "",
            //     permit_type: "",
            //     permit_issued_date: "",
            //     permit_valid_upto: "",
            //     upload_permit: "",
            //     insurance_number: "",
            //     insurance_company: "",
            //     insurance_issued_date: "",
            //     insurance_valid_upto: "",
            //     premium_amount: "",
            //     upload_insurance: "",
            //     puc_number: "",
            //     puc_issued_date: "",
            //     puc_valid_upto: "",
            //     upload_puc: "",
            //     declaration: 0,
            //     vehicle_type_id: "",
            // });
        }


    }, [])

    const [, setFiles] = useState({});
    const [loading, setLoading] = useState(false);
    const [snackbar, setSnackbar] = useState({ open: false, message: "", severity: "success" });
    const [uploading, setUploading] = useState({});



    // const handleChange = useCallback((e) => {
    //     const { name, value } = e.target;
    //     setForm((prev) => ({ ...prev, [name]: value }));
    // }, [])



    const handleChange = useCallback((e) => {

        const { name, value } = e.target;

        setForm((prev) => ({
            ...prev,
            [name]: value
        }));

    }, []);

    const FetchViewData = useCallback(async (bus_id) => {
        setLoadingDetails(true);
        setLoadError('');
        const payload = {
            "token": localStorage.getItem("token") || "",
            "users_id": user?.users_id || user?.id || "",
            "role_id": role_id,
            "bus_id": bus_id,
            "format": "Json"
        }

        try {
            const response = await post(ENDPOINTS.BUSESMASTER.VIEW_BUS, payload);

            if (!response?.data?.busMst || typeof response.data.busMst !== "object") throw new Error("Missing bus details");
            const data = response.data.busMst;
            // setForm(response?.data.busMst || {});
            setForm({
                ...defaultForm,
                ...data,
                vehicle_type_id: data.vehicle_type_id || ""
            });
        } catch (error) {
            setLoadError("Unable to load existing bus details. Please retry before saving.");
            console.error("Error fetching view data:", error);
        } finally {
            setLoadingDetails(false);
        }
    }, [editData])

    const uploadEndpointMap = useMemo(() => ({
        upload_photo_1: ENDPOINTS.BUSESMASTER.UPLOAD_PHOTO_1,
        upload_photo_2: ENDPOINTS.BUSESMASTER.UPLOAD_PHOTO_2,
        upload_photo_3: ENDPOINTS.BUSESMASTER.UPLOAD_PHOTO_3,
        upload_photo_4: ENDPOINTS.BUSESMASTER.UPLOAD_PHOTO_4,
        upload_rc: ENDPOINTS.BUSESMASTER.UPLOAD_RC,
        upload_fitness: ENDPOINTS.BUSESMASTER.UPLOAD_FITNESS,
        upload_permit: ENDPOINTS.BUSESMASTER.UPLOAD_PERMIT,
        upload_insurance: ENDPOINTS.BUSESMASTER.UPLOAD_INSURANCE,
        upload_puc: ENDPOINTS.BUSESMASTER.UPLOAD_PUC,
    }), []);

    const uploadFile = async (file, endpoint) => {
        if (!file || !endpoint) return "";
        const fd = new FormData();
        // include file under a common key 'images' like other uploads
        fd.append("token", localStorage.getItem("token") || "");
        fd.append("images", file);
        try {
            const res = await postFromData(endpoint, fd);
            // try common response shapes
            return (
                res?.data?.img_file || res?.file_url || res?.data?.file_url || res?.img_file || res?.data?.img_path || res?.data?.path || res?.data || ""
            );
        } catch (err) {
            console.error("Upload failed", err);
            return "";
        }
    };

    const handleFileChange = useCallback(async (e) => {
        const { name, files: f } = e.target;
        const file = f && f[0];
        if (!file) return;

        // optimistic local preview (object URL)
        const previewKey = `${name}_preview`;
        if (previewUrls.current[name]) URL.revokeObjectURL(previewUrls.current[name]);
        const previewUrl = URL.createObjectURL(file);
        previewUrls.current[name] = previewUrl;
        setForm((p) => ({ ...p, [previewKey]: previewUrl }));
        setUploadErrors(previous => ({ ...previous, [name]: false }));

        const endpoint = uploadEndpointMap[name];
        if (!endpoint) {
            // fallback: store locally and attach on submit
            setFiles((prev) => ({ ...prev, [name]: file }));
            return;
        }

        setUploading((u) => ({ ...u, [name]: true }));
        const url = await uploadFile(file, endpoint);
        setUploading((u) => ({ ...u, [name]: false }));

        if (typeof url === 'string' && url.trim()) {
            setForm((prev) => ({ ...prev, [name]: url }));
            setSnackbar({ open: true, message: "Uploaded successfully", severity: "success" });
        } else {
            setUploadErrors(previous => ({ ...previous, [name]: true }));
            setSnackbar({ open: true, message: "Upload failed", severity: "error" });
            // keep the file to allow retry on final submit
            setFiles((prev) => ({ ...prev, [name]: file }));
        }
    }, [uploadEndpointMap]);

    const handleCloseSnackbar = () => setSnackbar((s) => ({ ...s, open: false }));
    const handleSubmit = useCallback(async (e) => {

        e.preventDefault();
        if (!e.currentTarget.reportValidity()) return;
        if (submitting.current || loadingDetails || loadError || loading || Object.values(uploading).some(Boolean) || Object.values(uploadErrors).some(Boolean)) return;
        submitting.current = true;
        setLoading(true);
        let savedSuccessfully = false;

        try {

            const payload = {};

            Object.keys(form).forEach((key) => {
                if (!key.endsWith("_preview")) {
                    payload[key] = form[key] ?? "";
                }
            });

            payload.token = localStorage.getItem("token");
            payload.users_id = user?.users_id || user?.id;
            payload.role_id = role_id;

            let api = ENDPOINTS.BUSESMASTER.ADD_BUS;

            if (editData) {
                api = ENDPOINTS.BUSESMASTER.EDIT_BUS;
                payload.bus_id = editData.id;
            }



            const res = await post(api, payload);
            if (res?.status !== "success") throw new Error(res?.["success message"] || res?.message || "Failed to submit data");
            savedSuccessfully = true;

            setSnackbar({
                open: true,
                message: res?.message || "Saved successfully",
                severity: "success"
            });

            setTimeout(() => navigate(-1), 1000);

        } catch (error) {

            console.error(error);

            setSnackbar({
                open: true,
                message: error?.message || "Failed to submit data",
                severity: "error"
            });

        } finally {
            // Keep the successful form locked until its existing redirect completes.
            if (!savedSuccessfully) {
                submitting.current = false;
                setLoading(false);
            }
        }

    }, [form, role_id, user, editData, loading, loadingDetails, loadError, uploading, uploadErrors, navigate]);
    const busy = loadingDetails || Boolean(loadError) || loading || Object.values(uploading).some(Boolean);
    const certificate = (title, fields, uploadName, uploadLabel) => <BusFormSection key={uploadName} title={title}>
      <Box sx={{ display: 'grid', gridTemplateColumns: { xs: 'minmax(0,1fr)', md: 'minmax(0,1fr) minmax(210px,260px)' }, gap: 1.5, alignItems: 'start' }}><Grid container spacing={1.5}>
        {fields.map(([name,label,type = 'text',required = true]) => <Grid size={{ xs: 12, sm: 6 }} key={name}><TextField fullWidth name={name} label={label} type={type} required={required} value={form[name] || ''} onChange={handleChange} InputLabelProps={type === 'date' ? { shrink: true } : undefined} error={Boolean(fieldErrors[name])} helperText={fieldErrors[name]} /></Grid>)}
        </Grid><Box sx={{ minWidth: 0 }}><BusDocumentUpload name={uploadName} label={uploadLabel} value={form[uploadName]} required onChange={handleFileChange} uploading={uploading[uploadName]} /></Box></Box>
    </BusFormSection>;
    return <Box sx={busFormSx}>
      <Stack component="header" direction={{ xs: 'column', sm: 'row' }} gap={1.5} alignItems={{ xs: 'flex-start', sm: 'center' }} mb={2}>
        <Button type="button" variant="outlined" startIcon={<ArrowBack />} onClick={() => navigate('/buses')} sx={{ color: '#123047', borderColor: '#E2E8F0', minHeight: 40 }}>Back to Bus List</Button>
        <Box><Typography component="h1" sx={{ fontSize: { xs: 21, sm: 24 }, color: '#123047', fontWeight: 700 }}>{editData ? `Edit Bus${form.bus_number ? ' \u2014 ' + form.bus_number : ''}` : 'Add Bus'}</Typography><Typography sx={{ fontSize: 13, color: '#64748B', mt: .5 }}>Vehicle details and certificate management</Typography></Box>
      </Stack>
      {loadingDetails && <Alert severity="info" sx={{ mb: 1.5 }}>Loading existing bus details...</Alert>}
      {loadError && <Alert severity="error" action={<Button type="button" onClick={() => FetchViewData(editData.id)}>Retry</Button>} sx={{ mb: 1.5 }}>{loadError}</Alert>}
      {Object.values(uploadErrors).some(Boolean) && <Alert severity="error" sx={{ mb: 1.5 }}>A selected file could not be uploaded. Select the file again before saving.</Alert>}
      <Box component="form" aria-label="Bus details" onSubmit={handleSubmit} onInvalidCapture={event => { const target = event.target; if (target.name) setFieldErrors(previous => ({ ...previous, [target.name]: target.validationMessage })); }} onInputCapture={event => { const name = event.target.name; if (name) setFieldErrors(previous => ({ ...previous, [name]: '' })); }}>
        <Stack spacing={1.5}>
          <BusDetailComponent form={form} handleChange={handleChange} handleFileChange={handleFileChange} uploading={uploading} errors={fieldErrors} />
          {certificate('Fitness Certificate / \u092b\u093f\u091f\u0928\u0947\u0938 \u092a\u094d\u0930\u092e\u093e\u0923\u092a\u0924\u094d\u0930', [['fitness_number','Fitness Number'],['fitness_issued_date','Fitness Issued Date','date'],['fitness_valid_upto','Fitness Valid Upto','date']], 'upload_fitness','Fitness Document')}
          {certificate('Insurance / \u092c\u0940\u092e\u093e', [['insurance_company','Insurance Company'],['insurance_number','Insurance Number'],['premium_amount','Premium Amount','text',false],['insurance_issued_date','Insurance Issued Date','date'],['insurance_valid_upto','Insurance Valid Upto','date']], 'upload_insurance','Insurance Document')}
          {certificate('PUC / \u092a\u094d\u0930\u0926\u0942\u0937\u0923 \u092a\u094d\u0930\u092e\u093e\u0923\u092a\u0924\u094d\u0930', [['puc_number','PUC Number'],['puc_issued_date','PUC Issued Date','date'],['puc_valid_upto','PUC Valid Upto','date']], 'upload_puc','PUC Document')}
          <AddPermitComponent form={form} handleChange={handleChange} handleFileChange={handleFileChange} uploading={uploading} errors={fieldErrors} />
          <BusFormSection title="Declaration">
            <FormControlLabel sx={{ m: 0, alignItems: 'flex-start', '& .MuiTypography-root': { fontSize: 13, pt: 1 } }} control={<Checkbox name="declaration" checked={form.declaration === 1 || form.declaration === '1' || form.declaration === 'Yes'} onChange={event => handleChange({ target: { name: 'declaration', value: event.target.checked ? 1 : 0 } })} />} label="I hereby declare & truly verified by the school principle /administrator" />
          </BusFormSection>
          <Stack direction={{ xs: 'column-reverse', sm: 'row' }} justifyContent="flex-end" gap={1.5} sx={{ bgcolor: '#fff', border: '1px solid #E2E8F0', borderRadius: '12px', p: 1.75, '& .MuiButton-root': { minHeight: 44, minWidth: 130 } }}>
            <Button type="button" variant="outlined" onClick={() => navigate(-1)} sx={{ color: '#123047', borderColor: '#E2E8F0' }}>Cancel</Button>
            <Button type="submit" variant="contained" disabled={busy || Object.values(uploadErrors).some(Boolean)} startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <Save />}>{loading ? 'Saving...' : editData ? 'Update Bus' : 'Save Bus'}</Button>
          </Stack>
        </Stack>
      </Box>
      <Snackbar open={snackbar.open} autoHideDuration={4000} onClose={handleCloseSnackbar}><Alert onClose={handleCloseSnackbar} severity={snackbar.severity}>{snackbar.message}</Alert></Snackbar>
    </Box>;
};
export default AddBus;
